import React, { useState, useEffect } from "react";
import styles from "./CountDown.module.css";

function CountDown({
  heading,
  endTime,
  buttonColor,
  setContestParticipationTimeOut,
  timeoutText,
}) {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    setTimeLeft(getTimeLeft());
    const intervalId = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(intervalId);
  }, [endTime]);

  function getTimeLeft() {
    const totalSeconds = Math.round((new Date(endTime) - new Date()) / 1000);

    if (totalSeconds <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
      };
    }

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    setContestParticipationTimeOut(totalSeconds);
    return {
      days,
      hours,
      minutes,
      seconds,
      totalSeconds,
    };
  }
  return (
    <div className="flex flex-col items-center justify-center py-[20px]">
      <div className={styles.counterParent} style={{ color: buttonColor }}>
        {timeLeft?.totalSeconds >= 0 ? (
          <>
            <div className="text-largest">
              {timeLeft?.days} <span className="text-smallest">Days</span>
            </div>
            <div className="text-largest">
              {timeLeft?.hours} <span className="text-smallest">Hrs</span>
            </div>
            <div className="text-largest">
              {timeLeft?.minutes} <span className="text-smallest">Min</span>
            </div>
            <div className="text-largest">
              {timeLeft?.seconds} <span className="text-smallest">Sec</span>
            </div>
          </>
        ) : (
          <p className="text-regular-bold">
            {timeoutText || "Submission period ended"}
          </p>
        )}
      </div>
      <p
        dangerouslySetInnerHTML={{ __html: heading }}
        className="text-small mt-[16px] relative z-1 uppercase px-[50px]"
      />
    </div>
  );
}

export default CountDown;
